import { Hidden, Modal } from '@mui/material'
import IonIcon from '@reacticons/ionicons'
import { omitBy } from 'lodash'
import { useRouter } from 'next/router'
import React, { memo, useEffect, useState } from 'react'
// import { useGoogleReCaptcha } from 'react-google-recaptcha-v3'
import { TailSpin } from 'react-loading-icons'
import { ContentList } from 'src/components/ContentList/ContentList'
import { FilterOptions } from 'src/components/FilterOptions/FilterOptions'
import { Filter } from 'src/components/global/filter'
import { LoadingAnimation } from 'src/components/global/LoadingAnimation'
import { SearchField } from 'src/components/global/SearchField'
import { Sidebar } from 'src/components/global/Sidebar'
import { SortbyDropdown, SortByType } from 'src/components/global/SortbyDropdown'
import { Pagination } from 'src/components/Pagination/Pagination'
import { SHOW_RELATED_CONTENT, SHOW_RELATED_CONTENT_TO_ALL } from 'src/config/config'
// import { RECAPTCHA_ENABLED } from 'src/config/config'
import {
  IContentItem,
  IEnum_Content_Contenttype,
  useRelatedContentBySolutionLazyQuery,
  useShowRelatedContentFeatureLazyQuery,
  //useSearchContentsLazyQuery,
} from 'src/graphql/generated/hooks'
// import { useAuthDefender } from 'src/hooks/useAuthDefender'
import { useUpdateQueryParams } from 'src/hooks/useUpdateQueryParams'
import { FilterOption } from 'src/types'

interface Props {
  filterProps: FilterOption[]
  showDocumentType?: boolean
  contentType?: IEnum_Content_Contenttype
  filtersDisabled?: boolean
  preAppliedFilters?: { [key: string]: string }
  sortType?: SortByType
  onClickWhenDisabled?: () => void
  slug: string
  searchKeyword?: string
}

const pageSize = 10

export const SolutionContentsPagination: React.FC<Props> = memo(
  ({
    filterProps,
    showDocumentType = false,
    contentType,
    filtersDisabled = false,
    preAppliedFilters = {},
    sortType = 'contents',
    onClickWhenDisabled,
    slug,
    searchKeyword,
  }) => {
    //useAuthDefender()
    const router = useRouter()
    // const dispatch: Dispatch<any> = useDispatch()
    //const { executeRecaptcha } = useGoogleReCaptcha()

    const { updateQueryParams } = useUpdateQueryParams()
    const [currentPage, setCurrentPage] = useState(1)
    const [totalCount, setTotalCount] = useState(0)
    const [items, setCurrentItems] = useState<IContentItem[]>([])
    const [showFilterDlg, setShowFilterDlg] = useState(false)
    const [loadContents, { data: contentsData, loading }] = useRelatedContentBySolutionLazyQuery()
    const [loadShowRelatedContentFeature, { data: permissionData }] = useShowRelatedContentFeatureLazyQuery()
    const [checkFeaturePermission, setCheckFeaturePermission] = useState(false)

    useEffect(() => {
      const fetchData = async () => {
        try {
          await loadShowRelatedContentFeature()
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error('Error in checking that user have Show Related Content Permission')
        }
      }
      fetchData()
    }, [])

    useEffect(() => {
      if (permissionData?.showRelatedContentFeature || SHOW_RELATED_CONTENT_TO_ALL) {
        setCheckFeaturePermission(permissionData?.showRelatedContentFeature || SHOW_RELATED_CONTENT_TO_ALL)
      }
    }, [permissionData])

    useEffect(() => {
      ;(async () => {
        await timeout(500)
        const curPage = router.query.page ? parseInt(router.query.page as string) : 1
        const indexOfLastPost = curPage * pageSize
        const indexOfFirstPost = indexOfLastPost - pageSize
        const filters = router.query

        let selection: string[] = []
        if (filters.productType) {
          const paths = (filters.productType as string).split('_')
          const checks = paths[0].split(',')

          checks.map((check) => {
            const subTopicDocumentId = check.split('@@@@')[1]
            selection.push(subTopicDocumentId)
          })
        }
        selection = [...new Set(selection)]
        const newProductType = selection.join(',')
        const query = filtersDisabled
          ? {
              ...preAppliedFilters,
              slug: slug,
              contentType,
              offset: 0,
              //isTrending: true,
              keyword: filters?.keyword,
              limit: pageSize,
              sort:
                filters?.sort || (sortType === 'category_contents' ? 'Category_Chronologically' : 'Chronologically'),
            }
          : {
              keyword: filters?.keyword,
              slug: slug,
              contentType: contentType || filters?.contentType,
              documentType: filters?.documentType,
              audienceIds: filters?.audiences,
              //isTrending: true,
              subjectIds: filters?.subject,
              phaseIds: filters?.phase,
              subjectMatterIds: filters?.subjectMatter,
              themeIds: filters?.theme,
              blogTaxonomyIds: filters?.blogTaxonomyIds,
              subTopicIds: filters ? newProductType : undefined,
              vendorTopicIds: filters?.vendorTopic,
              writerIds: filters?.author,
              startDate: filters?.startDate,
              endDate: filters?.endDate,
              offset: indexOfFirstPost,
              limit: pageSize,
              sort:
                filters?.sort || (sortType === 'category_contents' ? 'Category_Chronologically' : 'Chronologically'),
              ...preAppliedFilters,
            }
        /*
        const gReCaptchaToken = ''

         if (RECAPTCHA_ENABLED) {
          if (!executeRecaptcha) {
            // dispatch(showToast('Execute recaptcha not yet available', 'error'))
            return
          }
          gReCaptchaToken = await executeRecaptcha('search_contents')
          loadContents({ variables: { query: omitBy(query, (value) => !value), gReCaptchaToken } })
        } */
        if (SHOW_RELATED_CONTENT) {
          loadContents({ variables: { query: omitBy(query, (value) => !value) }, fetchPolicy: 'no-cache' })
        }
      })()
    }, [currentPage, filtersDisabled, router, router.isReady, router.query])

    useEffect(() => {
      const curPage = router.query.page !== undefined ? parseInt(router.query.page as string) : 1
      if (contentsData) {
        //relatedContentData?.relatedContentBySolution?.data?.contents
        /* const posts: IContentItem[] =
          contentsData.contentResults?.data?.contents?.filter((content): content is IContentItem => !!content) || [] */
        const posts: IContentItem[] =
          contentsData?.relatedContentBySolution?.data?.contents?.filter(
            (content): content is IContentItem => !!content,
          ) || []
        setCurrentItems(posts)
        setTotalCount(contentsData?.relatedContentBySolution?.data?.total || 0)
      }
      setCurrentPage(curPage)
    }, [contentsData])

    const navigateToPage = (page: number) => {
      updateQueryParams({ page: page.toString() }, true)
    }

    // Change page
    const paginateFront = () => {
      if (filtersDisabled) {
        onClickWhenDisabled && onClickWhenDisabled()
        return
      }
      const lastpage = totalCount / pageSize
      if (currentPage < lastpage) {
        setCurrentPage(currentPage + 1)
        navigateToPage(currentPage + 1)
      }
    }
    const paginateBack = () => {
      if (filtersDisabled) {
        onClickWhenDisabled && onClickWhenDisabled()
        return
      }
      if (currentPage > 1) {
        setCurrentPage(currentPage - 1)
        navigateToPage(currentPage - 1)
      }
    }
    const paginate = (pageNumber: number) => {
      if (filtersDisabled) {
        onClickWhenDisabled && onClickWhenDisabled()
        return
      }
      setCurrentPage(pageNumber)
      navigateToPage(pageNumber)
    }
    function timeout(delay: number) {
      return new Promise((res) => setTimeout(res, delay))
    }
    return (
      <div className="flex flex-col flex-1">
        <div className="md:px-5 pt-5 md:pt-10">
          <Hidden mdDown>
            <FilterOptions
              filterOptions={filterProps}
              className="md:my-[1rem] md:mt-0 mt-[16px] md:mb-0 mb-[20px] min-h-[28px] mr-[180px]"
            />
          </Hidden>

          <div className="flex flex-row justify-between md:items-center h-10 md:mb-[1rem] font-primary font-medium">
            <Hidden mdDown>
              {loading && (
                <div className="flex items-center">
                  <TailSpin stroke="#011D58" height="2em" /> <div className="pl-3"> Loading...</div>
                </div>
              )}
              {!loading && (
                <div className="font-primary font-medium">
                  {totalCount === 0 || !checkFeaturePermission
                    ? 'No content found'
                    : `${totalCount ?? 0} Content${(totalCount ?? 0) > 1 ? 's' : ''} Found`}
                </div>
              )}
              <SortbyDropdown className="w-54 font-primary font-medium" searchKeyword={searchKeyword} type={sortType} />
            </Hidden>
            <Hidden mdUp>
              <div className="flex flex-col">
                <Filter onClickFilter={() => setShowFilterDlg(true)} />
              </div>
              <SortbyDropdown className="w-54 font-primary font-medium" searchKeyword={searchKeyword} type={sortType} />
            </Hidden>
          </div>

          <Hidden mdUp>
            <div className="flex flex-col">
              {loading && (
                <div className="flex items-center">
                  <TailSpin stroke="#011D58" height="2em" /> <div className="pl-3"> Loading...</div>
                </div>
              )}
              {!loading && (
                <div className="font-primary font-medium text-[12px] leading-[26px]">
                  {(totalCount ?? 0) > 0
                    ? `${totalCount ?? 0} Content${(totalCount ?? 0) > 1 ? 's' : ''} Found`
                    : `No content found`}
                </div>
              )}
              <FilterOptions
                filterOptions={filterProps}
                className="md:my-[1rem] md:mt-0 mt-[16px] md:mb-0 mb-[20px] min-h-[28px]"
              />
            </div>
          </Hidden>

          {loading && <LoadingAnimation></LoadingAnimation>}
          {!loading && (
            <>
              <ContentList
                items={checkFeaturePermission ? items : []}
                showDocumentType={showDocumentType}
                searchKeyword={searchKeyword}
              />
              {totalCount > 0 && checkFeaturePermission && (
                <Pagination
                  postsPerPage={pageSize}
                  totalPosts={totalCount}
                  paginateBack={paginateBack}
                  paginateFront={paginateFront}
                  paginate={paginate}
                  currentPage={currentPage}
                  className="md:pt-[1.875rem] pt-[0.875rem]"
                />
              )}
            </>
          )}
        </div>
        <Modal open={showFilterDlg}>
          <div className="flex flex-col w-full h-full bg-white p-[17px]">
            <div className="flex flex-row mb-[13px]">
              <p className="font-secondary font-bold text-[20px] text-darkgray items-center">Filter</p>
              <div className="ml-auto" onClick={() => setShowFilterDlg(false)}>
                <IonIcon name="close-outline" className="!h-[30px] !w-[30px] text-[black]" />
              </div>
            </div>
            <SearchField className="mb-[23px]" />
            <Sidebar filterOptions={filterProps} defaultSelectFilterIdx={1} />
            <button
              className="text-white font-secondary text-[14px] font-bold text-center rounded-[22.5px] px-[25px] bg-navy mt-auto mb-[15px] h-[50px] !important"
              onClick={() => setShowFilterDlg(false)}
            >
              Apply Filters
            </button>
          </div>
        </Modal>
      </div>
    )
  },
)
